import { createSelector } from 'reselect'

import selectGitHubRepositoryOwners from './selectGitHubRepositoryOwners'

export default createSelector(selectGitHubRepositoryOwners, owners => {
  return owners.map(({ id, login }) => ({ value: id, text: login }))
})
